import { gql } from '@apollo/client'

export default gql(`
    mutation c($user: String! $project: String){
        dismissAllNotification (
            user: $user
            project: $project
        ) {
             status
             error
        }
}`)
